/**
 * The CMS's visual editor frames our pages with this query flag. Shared by the
 * proxy (routing to the cms-edit route) and client code that must behave
 * differently inside the editor, where only the URL tells them.
 */
export const EDIT_MODE_PARAM = 'editMode';

export function isEditModeSearch(searchParams: URLSearchParams): boolean {
  return searchParams.get(EDIT_MODE_PARAM) === '1';
}
